const InputError = (props: any) => {
  return (
    <div className="text-red font-light text-sm">
      {props.children ? props.children : ""}
    </div>
  );
};

export default InputError;
